import {Order, OrderStatus} from "../../../model/Order";
import {Store} from "../../../model/Store";
import {Operation, OperationCustomerPlanningSetting} from "../../../model/Operation";
import {Cra} from "../../../model/Cra";
import {AdditionalTimes} from "../../../model/AdditionalTimes";
import {CustomerFeedBackValue} from "../../../model/CustomerFeedBackValue";
import {ActivityDate} from "../../../services/DateService";
import {DailyWorkerScheduleTemplate, SlotsForStoreReportSlot} from "../../../model/ReportingSlots";

/**
 * Class use in form to edit or create a new mission order
 */


export class UIMissionPlanningDetails {
  selected: boolean;
  details: string;
  name: string;
  purposeId: number;
}

export class OrderEditForm {

  public store: Store;
  public operation: Operation;
  public profil: number;
  public kit: number;

  public comment: string;
  public storeContact: string;
  public storeContactMobile: string;
  public storeContactInfoAccess: string;

  public csPresence: boolean;
  public appointment: string;
  public sharingCustomerSectorContactDetailsToWorker: boolean;
  public appointmentTime: string;

  public status: OrderStatus;
  public interventions: Intervention[];

  public nbDays: number;
  public days: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  public timeEdit: TimeEdit[] = new Array();

  public planificationSettings: OperationCustomerPlanningSetting;
  public cras: Cra[];

  public customerFeedBack: CustomerFeedBackValue;
  public additionalTimes: AdditionalTimes[] = [];

  public valid: boolean;
  public customerFeedBackValueList: CustomerFeedBackValue[];

  public customerSectorId: number;

  public uiFullyLoaded: boolean;
  public planningPurpose: number;
  public dailyTourPlanning: number;

  public uiMissionPlanningDetails: UIMissionPlanningDetails[];

  constructor(store: Store, operation: Operation, order: Order) {
    console.log("build order edit form")
    this.store = store;
    this.operation = operation;

    this.valid = false;

    this.interventions = [];

    this.timeEdit.push(new TimeEdit(0, "0:00"));
    this.timeEdit.push(new TimeEdit(30, "0:30"));
    this.timeEdit.push(new TimeEdit(60, "1:00"));
    this.timeEdit.push(new TimeEdit(90, "1:30"));
    this.timeEdit.push(new TimeEdit(120, "2:00"));
    this.timeEdit.push(new TimeEdit(150, "2:30"));
    this.timeEdit.push(new TimeEdit(180, "3:00"));
    this.timeEdit.push(new TimeEdit(210, "3:30"));
    this.timeEdit.push(new TimeEdit(240, "4:00"));
    this.timeEdit.push(new TimeEdit(270, "4:30"));
    this.timeEdit.push(new TimeEdit(300, "5:00"));
    this.timeEdit.push(new TimeEdit(330, "5:30"));
    this.timeEdit.push(new TimeEdit(360, "6:00"));
    this.timeEdit.push(new TimeEdit(390, "6:30"));
    this.timeEdit.push(new TimeEdit(420, "7:00"));

    if (order) {

      if (order.profil)
        this.profil = order.profil.id;

      this.comment = order.comment;
      this.status = order.status;

      if (order.cras != null)
        this.cras = order.cras;

      if (order.kit) {
        this.kit = order.kit.id;
      }

      if (order.planningPurpose != null)
        this.planningPurpose = order.planningPurpose.id;
      else if (order.plannedPurposes != null && order.plannedPurposes.length ==1)
        this.planningPurpose = order.plannedPurposes[0].purposeId;

      this.csPresence = order.csPresence;
      this.appointment = order.appointment;
      this.sharingCustomerSectorContactDetailsToWorker = order.sharingCustomerSectorContactDetailsToWorker;

      // date du rdv = date de l'intervention
      if (order.appointmentTime) {
        let dd = new Date(order.appointmentTime);
        this.appointmentTime = (dd.getHours() > 9 ? dd.getHours() : "0" + dd.getHours()) + ":"
          + (dd.getMinutes() > 9 ? dd.getMinutes() : "0" + dd.getMinutes());
        console.log(this.appointmentTime);
      }

      this.storeContact = order.storeContact;
      this.storeContactMobile = order.mobileStoreContact;
      this.storeContactInfoAccess = order.storeAccess;

      for (let p of order.activities) {

        let intervention: Intervention = new Intervention();
        intervention.id = p.id;
        // default value

        intervention.amDuration = this.timeEdit[0].value;
        intervention.pmDuration = this.timeEdit[0].value;

        // get only the date (time is to 0)
        intervention.logaDate = p.day;
        intervention.uiDisplayDate = new ActivityDate().withTimeStamp(p.day).computeShortLabel();


        if (p.amStartTime) {
          // convertir en heure
          intervention.amStartTime = new Date(p.amStartTime).toLocaleTimeString('fr-FR');
          let timeInMinute = Math.floor((p.amEndTime.valueOf() - p.amStartTime.valueOf()) / (60 * 1000));

          let timeEditFound: TimeEdit[] = this.timeEdit.filter(
            (mytimeedit) => {
              return mytimeedit.value === timeInMinute;
            }
          );
          if (timeEditFound && timeEditFound.length > 0) {
            intervention.amDuration = timeEditFound[0].value;
          }
        }

        if (p.pmStartTime) {
          // convertime en heure
          intervention.pmStartTime = new Date(p.pmStartTime).toLocaleTimeString('fr-FR');
          let timeInMinute = Math.floor((p.pmEndTime.valueOf() - p.pmStartTime.valueOf()) / (60 * 1000));

          let timeEditFound: TimeEdit[] = this.timeEdit.filter(
            (mytimeedit) => {
              return mytimeedit.value === timeInMinute;
            }
          );
          if (timeEditFound && timeEditFound.length > 0) {
            intervention.pmDuration = timeEditFound[0].value;
          }
        }

        intervention.planningSlotId = p.planningSlotId;
        intervention.dailyWorkerScheduleTemplateSlotId = p.dailyWorkerScheduleTemplateSlotId;

        this.interventions.push(intervention);

      }

      this.nbDays = order.activities.length;

      let diff: number = this.days.length - this.interventions.length;
      if (diff > 0) {
        // creation des autres interventions possibles
        for (let i = 0; i < diff; i++) {
          this.interventions.push(new Intervention());
        }
      }
      this.additionalTimes = order.additionalTimes;

    } else {
      for (let i in this.days) {
        this.interventions.push(new Intervention());
      }
    }
  }


  trimDays() {
    for (let i = 0; i < this.interventions.length; i++) {
      if (i >= this.nbDays) {
        this.interventions[i].uiDisplayDate = '';
        this.interventions[i].logaDate = null;
      }
    }
  }
}

/**
 * Activity
 */
export class Intervention {

  public id: number;

  public logaDate: number;

  public amStartTime: string;
  public amDuration: number;
  public pmStartTime: string;
  public pmDuration: number;

  // pour dire que l'intervention est valide (date valide avec au moins une heure et une durée saisie)
  public valid: boolean;

  public uiDisplayDate: string;
  public uiShowDataPicker: boolean = false;


  public planningSlots: SlotsForStoreReportSlot[] = null;

  public dailyWorkerScheduleTemplateSlotId: number;
  public planningSlotId: number;

  public uiSelectedSlot: SlotsForStoreReportSlot;
  public uiSelectedSlotTemplate: DailyWorkerScheduleTemplate;

  public validate() {
    if ((this.amStartTime != null && this.amDuration != null) || (this.pmStartTime != null && this.pmDuration != null)) {
      this.valid = true;
    } else {
      this.valid = false;
    }
  }

  private computeAmDuration(): number {
    let duration: number = 0;

    if (this.amDuration != null)
      duration = Number(this.amDuration);

    return duration;
  }

  private computePmDuration(): number {
    let duration: number = 0;

    if (this.pmDuration != null)
      duration = Number(this.pmDuration);

    return duration;
  }

  public computeDuration(): number {
    return this.computeAmDuration() + this.computePmDuration();
  }


  clear() {
    this.id = undefined;
    this.uiDisplayDate = '';
    this.logaDate = null;
    this.amStartTime = undefined;
    this.amDuration = undefined;
    this.pmStartTime = undefined;
    this.pmDuration = undefined;
  }
}

export class TimeEdit {
  constructor(public value: number, public label: string) {
  }
}






// WEBPACK FOOTER //
// ./src/pages/order-view/model/OrderEditForm.ts